<template>
  <div>
    <v-card>
      <v-card-title>
        {{ $t("STUDENT_NOMINATE_APPLICATION") }}
      </v-card-title>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn ref="applyBtn" :disabled="!ruleId || !certificateId"
               color="primary" dark v-bind="attrs" @click="runApprovalRule"
               v-on="on">
          {{ $t("APPLY_ACCEPTANCE_RULE") }}
        </v-btn>
      </v-card-actions>
      <v-card-content>
        <v-form ref="filterForm">
          <v-container>
            <v-row>
              <v-col cols="4" lg="4" md="4" sm="4" xs="4">
                <v-select
                    v-model="facultyId"
                    :items="serverTranslateArray(faculties, 'facultyName')"
                    :label="$t('FACULTY')"
                    class="col-9 d-inline-flex"
                    item-text="facultyName"
                    item-value="facultyId"
                    outlined
                    @change="showRules"
                ></v-select>
              </v-col>
              <v-col cols="4" lg="4" md="4" sm="4" xs="4">
                <v-select
                    v-model="certificateId"
                    :items="serverTranslateArray(CertificateBasicTypes, 'name')"
                    :label="$t('CERTIFICATE_TYPE')"
                    class="col-9 d-inline-flex"
                    item-text="name"
                    item-value="admissionId"
                    outlined
                    @change="showRules"
                ></v-select>
              </v-col>
              <v-col v-if="faculties.length > 0" cols="4" lg="4" md="4" sm="4" xs="4">
                <v-select
                    v-model="selectedDesire"
                    :items="DesireOptions"
                    :label="$t('DESIRES')"
                    outlined
                    @change="showRules"
                ></v-select>
              </v-col>

              <v-col cols="12">
                <v-alert
                    border="left"
                    class="pa-3"
                    colored-border
                    elevation="2"
                    type="info"
                >
                  <strong>{{ $t("APPROVAL_RULE_SPECIFICATION") }}</strong>
                  <div>
                    <span class="subheading secondary--text">{{ $t("ALLOWED_STUDENTCOUNT") }}:</span>
                    {{ studentNumber }}
                  </div>
                  <div>
                    <span class="subheading secondary--text">{{ $t("DEFAULT_STUDENTS_COUNT") }}:</span>
                    {{ totalDegree }}
                  </div>
                  <div>
                    <span class="subheading secondary--text">{{ $t("PERIORITY") }}:</span>
                    {{ (priorityId === 0 ? $t('FIRST_APPLY') : (priorityId === 1 ? $t('LARGEST_TOTAL') : '')) }}
                  </div>
                </v-alert>
              </v-col>

            </v-row>

          </v-container>
        </v-form>

      </v-card-content>
      <pr-confirmDialog ref="confirm"></pr-confirmDialog>
    </v-card>
    <v-card class="mt-5">
      <v-tabs
          v-model="tab"
          centered
          icons-and-text
      >
        <v-tabs-slider></v-tabs-slider>
        <v-tab class="secondary--text"
               href="#tab-1"
        >
          {{ $t("ACCEPT_CANDIDATES") }}
          <v-icon>mdi-account-check</v-icon>
        </v-tab>
        <v-tab class="secondary--text" href="#tab-2">
          {{ $t("REJECT_CANDIDATES") }}
          <v-icon>mdi-account-cancel</v-icon>
        </v-tab>

      </v-tabs>
      <div class="d-flex justify-right  my-2 mx-2">
        <v-btn v-if="acceptedStuWithoutLimit && acceptedStuWithoutLimit.length > 0" class="white--text" color="darken3"
               @click="acceptApplications(acceptedStuWithoutLimit)">
          {{ $t("ACCEPT_APPLICATIONS") }}
        </v-btn>
        <v-btn v-if="rejectedStuWithoutLimit && rejectedStuWithoutLimit.length > 0" class="white--text" color="darken3"
               @click="rejectApplications(rejectedStuWithoutLimit)">
          {{ $t("REJECT_APPLICATIONS") }}
        </v-btn>
      </div>
      <v-tabs-items v-model="tab">
        <v-tab-item
            value="tab-1"
        >
          <v-card flat>
            <v-card-content>
              <v-data-table
                  :footer-props="{
                         showFirstLastPage: true,
                         firstIcon: 'mdi-arrow-collapse-left',
                         lastIcon: 'mdi-arrow-collapse-right',
                         prevIcon: 'mdi-arrow-left',
                         nextIcon: 'mdi-arrow-right',
                         itemsPerPageOptions: [5,10,15,50,100],
                       }"
                  :headers="headers"
                  :hide-default-footer="acceptedStu.length > 0 ? false : true"
                  :items="serverTranslateArrayKeys(acceptedStu, ['studentName', 'facultyName', 'branch'])"
                  :items-per-page="10"
                  :loading="loading"
                  :options.sync="options1"
                  :server-items-length="totalPagesAccept"
                  class="elevation-1 pointer"
                  @click:row="openApplicationDetails($event)"
              ></v-data-table>
            </v-card-content>
          </v-card>
        </v-tab-item>
        <v-tab-item
            value="tab-2"
        >
          <v-card flat>
            <v-card-content>
              <v-data-table
                  :footer-props="{
                      showFirstLastPage: true,
                      firstIcon: 'mdi-arrow-collapse-left',
                      lastIcon: 'mdi-arrow-collapse-right',
                      prevIcon: 'mdi-arrow-left',
                      nextIcon: 'mdi-arrow-right',
                      itemsPerPageOptions: [5,10,15,50,100],
                    }"
                  :headers="headers"
                  :hide-default-footer="rejectedStu.length > 0 ? false : true"
                  :items="serverTranslateArrayKeys(rejectedStu, ['studentName', 'facultyName', 'branch'])"
                  :items-per-page="10"
                  :loading="loading"
                  :options.sync="options2"
                  :server-items-length="totalPagesReject"
                  class="elevation-1 pointer"
                  @click:row="openApplicationDetails($event)"
              ></v-data-table>
            </v-card-content>
          </v-card>
        </v-tab-item>
      </v-tabs-items>

      <ShowApplicationDetails/>
    </v-card>
  </div>
</template>
<script>
import globalMethodsMixin from "@/mixins/globalMethods.ts";
import serverTranslationsMixin from "@/mixins/serverTranslations.ts";
import ConfirmDialog from "@/components/shared/ConfirmDialog";
import ShowApplicationDetails from "@/components/modules/studentData/ManageApplications/ShowApplicationDetails";
import {EventBus} from "@/plugins/bus";

export default {
  mixins: [serverTranslationsMixin, globalMethodsMixin],
  components: {
    "pr-confirmDialog": ConfirmDialog,
    ShowApplicationDetails
  },
  mounted() {
    this.$store.state.Auth.facultyID = null;
    this.getFacultiesWithRules()
    this.acceptedStu=[]
    this.rejectedStu=[]
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const mv = this;
    EventBus.$on("updateRunListAfterAction", () => {
      if (this.tab === 'tab-1') {
        mv.getAccepted(false);
      } else {
        mv.getRejected(false);
      }
    });
  },
  data() {
    return {
      grouped: [],
      faculties: [],
      availableCert: [],
      CertificateBasicTypes: [],
      priorityId: "",
      facultyId: "",
      certificateId: "",
      studentNumber: 0,
      totalDegree: 0,
      ruleId: false,//Tables
      tab: "tab-1",
      loading: false,
      options1: {},
      options2: {},
      statusStudent: 1,
      acceptedStu: [],
      acceptedStuWithoutLimit: [],
      rejectedStuWithoutLimit: [],
      rejectedStu: [],
      totalPagesAccept: 0,
      totalPagesReject: 0,
      selectedDesire: ""
    }
  },
  methods: {
    onSelectionChange() {
    this.acceptedStu = []
    this.rejectedStu = []
    this.tab = "tab-1"
  },
    getFacultiesWithRules() {
      const rules = {
        "hasRules": true
      }
      this.$http.post("/api/general_data/list_faculties_with_rules/", rules)
          .then(
              res => {
                this.faculties = res.data.data.faculties;
                this.CertificateBasicTypes = res.data.data.CertificateBasicTypes;
                this.availableCert = res.data.data.CertificateBasicTypes;
                this.grouped = this.faculties.reduce((acc, item) => {
                  if (!acc[item.facultyId]) {
                    acc[item.facultyId] = {
                      facultyId: item.facultyId,
                      certificateIds: []
                    };
                  }
                  acc[item.facultyId].certificateIds.push(item.certificateId);
                  return acc;
                }, {});
              },
              err => {
                this.showToasted("error", err.response.data.message)
              })
    },
    showFacRulesCertificate() {
      this.CertificateBasicTypes = this.availableCert
      this.CertificateBasicTypes = this.CertificateBasicTypes.filter(
          cert => this.grouped[this.facultyId].certificateIds.includes(cert.admissionId)
      )
    },
    showRules() {
      this.studentNumber=0
      this.totalDegree=0
      this.priorityId=''
      this.showFacRulesCertificate()
      this.onSelectionChange()
      this.studentNumber = this.faculties.find(
          e => (e.facultyId === this.facultyId && e.certificateId === this.certificateId)
      ).studentNumber
      this.priorityId = this.faculties.find(
          e => (e.facultyId === this.facultyId && e.certificateId === this.certificateId)
      ).priorityId
      this.totalDegree = this.faculties.find(
          e => (e.facultyId === this.facultyId && e.certificateId === this.certificateId)
      ).totalDegree
      this.certificateId = this.faculties.find(
          e => (e.facultyId === this.facultyId && e.certificateId === this.certificateId)
      ).certificateId
      this.ruleId = this.faculties.find(
          e => (e.facultyId === this.facultyId && e.certificateId === this.certificateId)
      ).ruleId
      // /***************Reset Table options*******************/
      // this.tab = "tab-1";
      // this.getAccepted(true);
    },
    resetSearchView() {
      this.tab = "tab-1";
      this.getAccepted(true);
    },
    acceptApplications(acceptedStuWithoutLimit) {
      this.$refs.confirm
          .open("CONFIRMATION_MESSAGE", "ACCEPT_ALL_APPLICATION_CONFIRM")
          .then(confirm => {
            if (confirm) {
              const data = {
                "appStudentData": acceptedStuWithoutLimit,
                "statusStudentUpdated": "2"
              }
              this.$http.put("/api/approval_rules/edit_status_all_recommended/", data)
                  .then(
                      res => {
                        this.showToasted("success", res.data.message)
                        this.getAccepted();
                      },
                      err => {
                        this.showToasted("error", err.response.data.message)
                      }
                  )

            }
          })

    },
    rejectApplications(rejectedStuWithoutLimit) {
      this.$refs.confirm
          .open("CONFIRMATION_MESSAGE", "REFUSE_ALL_APPLICATIONS_CONFIRM")
          .then(confirm => {
            if (confirm) {
              const data = {
                "appStudentData": rejectedStuWithoutLimit,
                "statusStudentUpdated": "3"
              }
              this.$http.put("/api/approval_rules/edit_status_all_recommended/", data)
                  .then(
                      res => {
                        this.showToasted("success", res.data.message)
                        this.getAccepted();
                      },
                      err => {
                        this.showToasted("error", err.response.data.message)
                      }
                  )

            }
          })


    },
    runApprovalRule() {
     this.loading = true
      this.$refs.applyBtn.$el.style.display = 'none';
      this.$refs.confirm
          .open("CONFIRMATION_MESSAGE", "APPLY_RULE_CONFIRM")
          .then(confirm => {
            if (confirm) {
              this.resetSearchView();
              const data = {
                "facultyId": this.facultyId,
                "certificateId": this.certificateId,
                "ruleId": this.ruleId,
                "yearId": this.$store.getters.getActiveAcademicYear.id,
                "semesterId": this.$store.getters.getActiveAcademicSemester.id,
                "selectedDesire": this.selectedDesire
              }
              this.$http.post("/api/approval_rules/apply_rules/", data)
                  .then(
                      res => {
                         this.loading = true
                        this.showToasted("success", res.data.message)
                        this.getAccepted();
                      },
                      err => {
                         this.loading = true
                        this.showToasted("error", err.response.data.message)
                      }
                  )
            }

          })
      this.$refs.applyBtn.$el.style.display = 'block';

    },
    getAccepted(useDefaultOption = true) {
      if (useDefaultOption) {
        this.options1.page = 1;
        this.options1.sortBy = [];
        this.options1.sortDesc = [];
        this.options1.itemsPerPage = 10;
      }
      if (!this.facultyId)
        return false;
      this.loading = true;
      return new Promise((resolve, reject) => {
        const {sortBy, sortDesc, page, itemsPerPage} = this.options1
        const data = {
          "statusStudent": 1,
          "facultyId": this.facultyId,
          "yearId": this.$store.getters.getActiveAcademicYear.id,
          "semesterId": this.$store.getters.getActiveAcademicSemester.id,
          "page": page,
          "pageSize": itemsPerPage,
          "orderType": "asc",
          "orderBy": "applyDate",
          "desireNumber": this.selectedDesire
        }
        if (sortDesc && sortDesc.length === 1 && sortBy.length === 1) {
          data["orderType"] = sortDesc[0] ? "asc" : "desc"
          data["orderBy"] = sortBy[0]
        }
        this.acceptedStu = []
        this.loading = true
        this.$http.post("/api/approval_rules/get_all_recommended/", data)
            .then(
                res => {
                  this.acceptedStu = res.data.data.studentsData.results;
                  this.acceptedStuWithoutLimit = res.data.data.allData;
                  this.totalPagesAccept = res.data.data.studentsData.total;

                  this.loading = false
                  resolve({
                    "items": this.acceptedStu,
                    "total": this.totalPagesAccept,
                  });
                  this.rejectedStu = []
                  this.rejectedStuWithoutLimit = []
                },
                err => {
                  this.loading = false
                  this.showToasted("error", err.response.data.message)
                }
            )
      })
    },
    getRejected(useDefaultOption = true) {
      if (useDefaultOption) {
        this.options2.page = 1;
        this.options2.sortBy = [];
        this.options2.sortDesc = [];
        this.options2.itemsPerPage = 10;
      }
      if (!this.facultyId)
        return false;

      this.loading = true
      return new Promise((resolve, reject) => {
        const {sortBy, sortDesc, page, itemsPerPage} = this.options2
        const data = {
          "statusStudent": 0,
          "facultyId": this.facultyId,
          "yearId": this.$store.getters.getActiveAcademicYear.id,
          "semesterId": this.$store.getters.getActiveAcademicSemester.id,
          "page": page,
          "pageSize": itemsPerPage,
          "orderType": "asc",
          "orderBy": "applyDate",
          "desireNumber": this.selectedDesire
        }
        if (sortDesc && sortDesc.length === 1 && sortBy.length === 1) {
          data["orderType"] = sortDesc[0] ? "asc" : "desc"
          data["orderBy"] = sortBy[0]
        }
        this.rejectedStu = []
        this.$http.post("/api/approval_rules/get_all_recommended/", data)
            .then(
                res => {
                  this.rejectedStu = res.data.data.studentsData.results
                  this.rejectedStuWithoutLimit = res.data.data.allData;
                  this.totalPagesReject = res.data.data.studentsData.total
                  this.loading = false
                  resolve({
                    "items": this.rejectedStu,
                    "total": this.totalPagesReject,
                  });
                  this.acceptedStu = []
                  this.acceptedStuWithoutLimit = []
                },
                err => {
                  this.loading = false
                  this.showToasted("error", err.response.data.message)
                }
            )

      })
    },
    openApplicationDetails($event) {
      const applicationId = $event.applyId;
      const studentId = $event.studentId;
      EventBus.$emit('showApplicationDetails', applicationId, studentId, false)
    }
  },
  watch: {
    tab() {
      if (this.tab === 'tab-1') {
        this.getAccepted(true);
      } else {
        this.getRejected(true);
      }
    },
    options1() {
      this.getAccepted(false);
    },
    options2() {
      this.getRejected(false)
    },
  },
  computed: {
    direction: function () {
      return this.$store.state.direction;
    },
    DesireOptions() {
      const options = this.faculties.map((_, index) => ({
        text: this.$t('DESIRE') + ' ' + (index + 1),
        value: (index + 1),
      }));

      options.unshift({
        text: this.$t('SELECT_DESIRE'),
        value: '',
      });

      return options;

    },
    headers: function () {
      return [
        {
          text: this.$t("STUDENT_NAME"),
          align: "start",
          value: "studentName",
          sortable: false,
        },
        {
          text: this.$t("FACULTY_NAME"),
          value: "facultyName",
          sortable: false
        },
        {
          text: this.$t("BRANCH"),
          value: "branch",
          sortable: false
        },
        {
          text: this.$t("TOTAL_DEGREE"),
          value: "totalDegree",
          sortable: true
        },{
          text: this.$t("CERTIFIED_DEGREE"),
          value: "submittedTotal",
          sortable: true
        },
        {
          text: this.$t("APPLY_DATE"),
          value: "applyDate",
          sortable: true
        },
        {
          text: this.$t("STUDENT_NID"),
          value: "studentIdentity",
          sortable: false,
        }
      ];
    }
  },
};
</script>
